module.exports = __webpack_public_path__ + "static/media/delete.4c837169.svg";